import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import AirportChangeImage from 'shared/icons/airport_change.svg'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { useDialogBottomSheet } from 'shared/ui/dialog-bottom-sheet/lib'

import { TransferModal } from '../transfer-modal'

import { airportList } from './constants/lists'
import s from './styles.module.scss'

export const AirportChange = () => {
  const { openDialog } = useDialogBottomSheet()
  const { t } = useTranslation()

  const onOpenDialog = () => {
    openDialog({
      child: (
        <TransferModal
          title={t('transfer_details.airport_change.title')}
          description={t('transfer_details.airport_change.description')}
          subtitle={t('transfer_details.airport_change.subtitle')}
          image={AirportChangeImage}
          list={airportList}
        />
      ),
    })
  }
  return (
    <div
      className={s.airportChange}
      onClick={onOpenDialog}
    >
      <h4 className={clsx(s.text, 'semi-bold-11')}>
        {t('transfer_details.airport_change.title')}
      </h4>
      <AppIcon
        id={AllIcons.INFO}
        className={s.icon}
        height={16}
        width={16}
      />
    </div>
  )
}
